'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalPizza = function MdLocalPizza(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 25c1.8 0 3.4-1.6 3.4-3.4s-1.6-3.2-3.4-3.2-3.4 1.4-3.4 3.2 1.6 3.4 3.4 3.4z m-8.4-13.4c0 1.8 1.6 3.4 3.4 3.4s3.4-1.6 3.4-3.4-1.6-3.2-3.4-3.2-3.4 1.4-3.4 3.2z m8.4-8.2c5.9 0 11.3 2.5 15 6.6l-15 26.6-15-26.6c3.7-4.1 9.1-6.6 15-6.6z' })
        )
    );
};

exports.default = MdLocalPizza;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-pizza.js
// module id = 1189
// module chunks = 36573943044255 79611799117203 213534597649335